import { useState } from "react";

function PhysicsToolkit({ language, onInsertSymbol }) {
  const [showTools, setShowTools] = useState(false);

  const symbolButtonStyle = {
    fontSize: "21px",
    padding: "10px 14px",
    margin: "5px",
    minWidth: "58px",
    borderRadius: "10px",
    cursor: "pointer",
    border: "1px solid #d1d5db",
    background: "white",
  };

  const sectionHeadingStyle = {
    marginTop: "25px",
    marginBottom: "8px",
  };

  const renderButtons = (symbols) =>
    symbols.map((symbol) => (
      <button
        key={symbol}
        type="button"
        style={symbolButtonStyle}
        onClick={() => onInsertSymbol(symbol)}
      >
        {symbol}
      </button>
    ));

  return (
    <div
      style={{
        marginTop: "20px",
        background: "white",
        padding: "15px",
        borderRadius: "10px",
        marginBottom: "15px",
      }}
    >
      <button
        type="button"
        onClick={() =>
          setShowTools((previousValue) => !previousValue)
        }
        style={{
          fontSize: "18px",
          padding: "12px",
          borderRadius: "10px",
          cursor: "pointer",
          marginBottom: "15px",
          background: "#2563eb",
          color: "white",
          border: "none",
        }}
      >
        {language === "af"
          ? "⚛️ Fisikahulpmiddels"
          : "⚛️ Physics Toolkit"}
      </button>

      {showTools && (
        <>
          <a
            href="/Physics_formulas.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "10px 14px",
              borderRadius: "8px",
              background: "#eff6ff",
              color: "#1d4ed8",
              fontWeight: "bold",
              textDecoration: "none",
              border: "1px solid #bfdbfe",
            }}
          >
            {language === "af"
              ? "📄 Maak die Fisika-data- en formuleblad oop"
              : "📄 Open the Physics data and formula sheet"}
          </a>

          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "🧭 Vektore en beweging"
              : "🧭 Vectors and motion"}
          </h4>
          {renderButtons([
            "Δx",
            "Δy",
            "Δt",
            "vᵢ",
            "v𝒇",
            "a",
            "→",
            "↑",
            "↓",
            "←",
          ])}

          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "⚡ Elektriese hoeveelhede"
              : "⚡ Electrical quantities"}
          </h4>
          {renderButtons([
            "V",
            "I",
            "R",
            "ε",
            "Q",
            "E",
            "W",
            "P",
            "Ω",
          ])}

          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "📐 Wiskundige simbole"
              : "📐 Mathematical symbols"}
          </h4>
          {renderButtons([
            "Δ",
            "θ",
            "λ",
            "μ",
            "√",
            "²",
            "³",
            "×10⁻³",
            "×10⁻⁶",
            "×10⁻⁹",
          ])}

          <h4 style={sectionHeadingStyle}>
            {language === "af" ? "📏 SI-eenhede" : "📏 SI units"}
          </h4>
          {renderButtons([
            "m·s⁻¹",
            "m·s⁻²",
            "kg",
            "N",
            "J",
            "W",
            "Hz",
            "C",
            "V",
            "A",
            "Ω",
          ])}
        </>
      )}
    </div>
  );
}

export default PhysicsToolkit;
